import axios from "axios";

Object.assign(axios.defaults, {
  baseURL: process.env.NODE_ENV === "development" ? "/apiAll" : ""
});
// 首页banner
export function getBannerList() {
  const url = `/hhxh/api/index/getBannerList`;
  return axios.get(url).then(res => {
    return Promise.resolve(res.data);
  });
}

// 首页会员
export function getMemberList() {
  const url = `/hhxh/api/index/getMemberList`;
  return axios.get(url).then(res => {
    return Promise.resolve(res.data);
  });
}

// 首页微刊
export function getIndexMagazineList() {
  const url = `/hhxh/api/index/getIndexMagazineList`;
  return axios.get(url).then(res => {
    return Promise.resolve(res.data);
  });
}

// 首页新闻导航
export function getNewsCategoryList() {
  const url = `/hhxh/api/index/getNewsCategoryList`;
  return axios.get(url).then(res => {
    return Promise.resolve(res.data);
  });
}

// 首页新闻
export function getNewsList(id) {
  const url = `/hhxh/api/index/getNewsList`;
  return axios
    .get(url, {
      params: {
        categoryId: id
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

// 关于我们简介
export function getSocietyIntroduction() {
  const url = `/hhxh/api/aboutUs/getSocietyIntroduction`;
  return axios.get(url).then(res => {
    return Promise.resolve(res.data);
  });
}

// 关于我们规章制度
export function getRulesRegulation() {
  const url = `/hhxh/api/aboutUs/getRulesRegulation`;
  return axios.get(url).then(res => {
    return Promise.resolve(res.data);
  });
}

// 关于我们获取学会荣誉
export function getSocietyHonors() {
  const url = `/hhxh/api/aboutUs/getSocietyHonors`;
  return axios.get(url).then(res => {
    return Promise.resolve(res.data);
  });
}

// 关于我们大事记
export function getMemorabilia() {
  const url = `/hhxh/api/aboutUs/getMemorabilia`;
  return axios.get(url).then(res => {
    return Promise.resolve(res.data);
  });
}

// 关于我们理事会
export function getCouncilMember(data) {
  const url = `/hhxh/api/aboutUs/getCouncilMember`;
  return axios
    .get(url, {
      params: {
        pageNum: data.pageNum,
        pageSize: data.pageSize
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

// 新闻导航分类
export function getCategoryList() {
  const url = `/hhxh/api/news/getCategoryList`;
  return axios.get(url).then(res => {
    return Promise.resolve(res.data);
  });
}

// 新闻列表
export function newsGetNewsList(data) {
  const url = `/hhxh/api/news/getNewsList`;
  return axios
    .get(url, {
      params: {
        pageNum: data.pageNum,
        pageSize: data.pageSize,
        categoryId: data.categoryId
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

// 新闻详情
export function getNewsDetail(id) {
  const url = `/hhxh/api/news/getNewsDetail`;
  return axios
    .get(url, {
      params: {
        id: id
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

// 微刊列表
export function getPeriodicalList(data) {
  const url = `/hhxh/api/periodical/getPeriodicalList`;
  return axios
    .get(url, {
      params: {
        pageNum: data.pageNum,
        pageSize: data.pageSize,
        category: data.categoryId
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

// 微刊详情
export function getPeriodicalDetail(id) {
  const url = `/hhxh/api/periodical/getPeriodicalDetail`;
  return axios
    .get(url, {
      params: {
        id: id
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

// 交流咨询分类名称
export function getExchangeConsultCategory() {
  const url = `/hhxh/api/acaExchange/getExchangeConsultCategory`;
  return axios.get(url).then(res => {
    return Promise.resolve(res.data);
  });
}

// 专业委员会列表
export function getProfessionalCommitteeList() {
  const url = `/hhxh/api/acaExchange/getProfessionalCommitteeList`;
  return axios.get(url).then(res => {
    return Promise.resolve(res.data);
  });
}

// 专业委员会详情
export function getExpertShowDetail(id) {
  const url = `/hhxh/api/acaExchange/getExpertShowDetail`;
  return axios
    .get(url, {
      params: {
        id: id
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
// 	获取专家展示列表
export function getExpertShowList(data) {
  const url = `/hhxh/api/acaExchange/getExpertShowList`;
  return axios
    .get(url, {
      params: {
        pageNum: data.pageNum,
        pageSize: data.pageSize,
        category: data.category
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
// 购买需求提交
export function needPurchase(data) {
  const url = `/hhxh/api/periodical/needPurchase`;
  return axios.post(url, data).then(res => {
    return Promise.resolve(res.data);
  });
}
// 留言反馈
export function addConsult(data) {
  const url = `/hhxh/api/consult/addConsult`;
  return axios.post(url, data).then(res => {
    return Promise.resolve(res.data);
  });
}

// 注册
export function register(data) {
  const url = `/hhxh/api/member/register`;
  return axios.post(url, data).then(res => {
    return Promise.resolve(res.data);
  });
}

// 获取验证码
export function sendCode(mobile) {
  const url = `/hhxh/api/member/sendCode`;
  return axios
    .get(url, {
      params: {
        mobile: mobile
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

// 获取杂志库
export function getMagazineList() {
  const url = `/hhxh/api/magazine/getMagazineList`;
  return axios.get(url).then(res => {
    return Promise.resolve(res.data);
  });
}

// 阅读杂志  get请求  杂志ID
export function readMagazine(magazineId, userId) {
  const url = `/hhxh/api/magazine/readMagazine`;
  return axios
    .get(url, {
      params: {
        magazineId,
        userId
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

// 查看阅读记录
export function getMagazineRecord(userId) {
  const url = `/hhxh/api/magazine/getMagazineRecord`;
  return axios
    .get(url, {
      params: {
        userId
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}
// 清除阅读记录
export function clearReadRecord(data) {
  const url = `/hhxh/api/magazine/clearReadRecord`;
  return axios
    .get(url, {
      params: {
        userId: data.userId
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

// 验证用户
export function memberLogin(openId) {
  const url = `/hhxh/api/wechat/memberLogin`;
  return axios
    .get(url, {
      params: {
        openId
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

// 获取活动列表
export function getActivityList(data) {
  const url = `/hhxh/api/activity/getActivityList`;
  return axios
    .get(url, {
      params: {
        pageNum: data.pageNum,
        pageSize: data.pageSize
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

// 获取活动详情
export function getActivityDetail(id) {
  const url = `/hhxh/api/activity/getActivityDetail`;
  return axios
    .get(url, {
      params: {
        id
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

// 活动订单
export function enrollActivity(data) {
  const url = `/hhxh/api/pay/enrollActivity`;
  return axios.post(url, data).then(res => {
    return Promise.resolve(res.data);
  });
}

// 单位会员申请
export function applyForCompanyMember(data) {
  const url = `/hhxh/api/member/applyForCompanyMember`;
  return axios.post(url, data).then(res => {
    return Promise.resolve(res.data);
  });
}

// 个人会员申请
export function applyForMember(data) {
  const url = `/hhxh/api/pay/applyForMember`;
  return axios.post(url, data).then(res => {
    return Promise.resolve(res.data);
  });
}

// 高级职称
export function getSeniorTitleInfo() {
  const url = `/hhxh/api/seniorTitle/getSeniorTitleInfo`;
  return axios.get(url).then(res => {
    return Promise.resolve(res.data);
  });
}

// 高级职称
export function getApiSeniorTitleLinkList() {
  const url = `/hhxh/api/seniorTitle/getApiSeniorTitleLinkList`;
  return axios.get(url).then(res => {
    return Promise.resolve(res.data);
  });
}

//
export function getParam(urlItem) {
  const url = `/hhxh/api/wechat/getParam`;
  return axios
    .get(url, {
      params: {
        url: urlItem
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

// PC端访问量统计
export function addVisits() {
  const url = `/hhxh/api/index/addVisits`;
  return axios.get(url).then(res => {
    return Promise.resolve(res.data);
  });
}

// 富文本
export function getProfessionalCommittee() {
  const url = `/hhxh/api/acaExchange/getProfessionalCommittee`;
  return axios.get(url).then(res => {
    return Promise.resolve(res.data);
  });
}

// 获取个人信息
export function getMemberInfo(Id) {
  const url = `/hhxh/api/member/getMemberInfo`;
  return axios
    .get(url, {
      params: {
        userId: Id
      }
    })
    .then(res => {
      return Promise.resolve(res.data);
    });
}

// 修改个人资料
export function editMemberInfo(data) {
  const url = `/hhxh/api/member/editMemberInfo`;
  return axios.post(url, data).then(res => {
    return Promise.resolve(res.data);
  });
}
